export function isValidNumber(num: number | undefined | null): num is number {
  return num !== null && num !== undefined && !Number.isNaN(num);
}
